/**
* @file 系统设置-短信管理
* */
<template>
  <div id="sms">
    <tab-frame :tabs="tabs"></tab-frame>
  </div>
</template>

<script>
export default {
  name: "sms",
  data() {
    return {
      // tabs列表
      tabs: [
        { label: "短信模板", name: "/smsTemplate", icon: 'el-icon-document-copy' },
        { label: "短信记录", name: "/smsRecord", icon: 'el-icon-chat-dot-round' },
        { label: "短信统计", name: "/smsStatistics", icon: 'el-icon-data-line' },
        { label: "账户配置", name: "/smsConfig", icon: 'el-icon-setting' },
      ],
    };
  },
};
</script>

<style lang="less">
</style>
